"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function TableauNlpRefinementuiWidgetFromJSON(json) {
    return TableauNlpRefinementuiWidgetFromJSONTyped(json, false);
}
exports.TableauNlpRefinementuiWidgetFromJSON = TableauNlpRefinementuiWidgetFromJSON;
function TableauNlpRefinementuiWidgetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dateFilterWidget': !runtime_1.exists(json, 'date_filter_widget') ? undefined : _1.TableauNlpRefinementuiWidgetDateFilterWidgetFromJSON(json['date_filter_widget']),
        'limitWidget': !runtime_1.exists(json, 'limit_widget') ? undefined : _1.TableauNlpRefinementuiWidgetLimitWidgetFromJSON(json['limit_widget']),
        'sortWidget': !runtime_1.exists(json, 'sort_widget') ? undefined : _1.TableauNlpRefinementuiWidgetSortWidgetFromJSON(json['sort_widget']),
        'fieldWidget': !runtime_1.exists(json, 'field_widget') ? undefined : _1.TableauNlpRefinementuiWidgetFieldWidgetFromJSON(json['field_widget']),
        'categoricalFilterWidget': !runtime_1.exists(json, 'categorical_filter_widget') ? undefined : _1.TableauNlpRefinementuiWidgetCategoricalFilterWidgetFromJSON(json['categorical_filter_widget']),
        'quantitativeFilterWidget': !runtime_1.exists(json, 'quantitative_filter_widget') ? undefined : _1.TableauNlpRefinementuiWidgetQuantitativeFilterWidgetFromJSON(json['quantitative_filter_widget']),
        'vizTypeWidget': !runtime_1.exists(json, 'viz_type_widget') ? undefined : _1.TableauNlpRefinementuiWidgetVizTypeWidgetFromJSON(json['viz_type_widget']),
        'tableCalcWidget': !runtime_1.exists(json, 'table_calc_widget') ? undefined : _1.TableauNlpRefinementuiWidgetTableCalcWidgetFromJSON(json['table_calc_widget']),
        'nestedSortWidget': !runtime_1.exists(json, 'nestedSortWidget') ? undefined : json['nestedSortWidget'],
        'nestedLimitWidget': !runtime_1.exists(json, 'nestedLimitWidget') ? undefined : json['nestedLimitWidget'],
        'nestedFieldWidget': !runtime_1.exists(json, 'nestedFieldWidget') ? undefined : json['nestedFieldWidget'],
        'nestedDateFilterWidget': !runtime_1.exists(json, 'nestedDateFilterWidget') ? undefined : json['nestedDateFilterWidget'],
        'nestedQuantitativeFilterWidget': !runtime_1.exists(json, 'nestedQuantitativeFilterWidget') ? undefined : json['nestedQuantitativeFilterWidget'],
        'nestedCategoricalFilterWidget': !runtime_1.exists(json, 'nestedCategoricalFilterWidget') ? undefined : json['nestedCategoricalFilterWidget'],
        'nestedVizTypeWidget': !runtime_1.exists(json, 'nestedVizTypeWidget') ? undefined : json['nestedVizTypeWidget'],
        'nestedTableCalcWidget': !runtime_1.exists(json, 'nestedTableCalcWidget') ? undefined : json['nestedTableCalcWidget'],
    };
}
exports.TableauNlpRefinementuiWidgetFromJSONTyped = TableauNlpRefinementuiWidgetFromJSONTyped;
function TableauNlpRefinementuiWidgetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date_filter_widget': _1.TableauNlpRefinementuiWidgetDateFilterWidgetToJSON(value.dateFilterWidget),
        'limit_widget': _1.TableauNlpRefinementuiWidgetLimitWidgetToJSON(value.limitWidget),
        'sort_widget': _1.TableauNlpRefinementuiWidgetSortWidgetToJSON(value.sortWidget),
        'field_widget': _1.TableauNlpRefinementuiWidgetFieldWidgetToJSON(value.fieldWidget),
        'categorical_filter_widget': _1.TableauNlpRefinementuiWidgetCategoricalFilterWidgetToJSON(value.categoricalFilterWidget),
        'quantitative_filter_widget': _1.TableauNlpRefinementuiWidgetQuantitativeFilterWidgetToJSON(value.quantitativeFilterWidget),
        'viz_type_widget': _1.TableauNlpRefinementuiWidgetVizTypeWidgetToJSON(value.vizTypeWidget),
        'table_calc_widget': _1.TableauNlpRefinementuiWidgetTableCalcWidgetToJSON(value.tableCalcWidget),
        'nestedSortWidget': value.nestedSortWidget,
        'nestedLimitWidget': value.nestedLimitWidget,
        'nestedFieldWidget': value.nestedFieldWidget,
        'nestedDateFilterWidget': value.nestedDateFilterWidget,
        'nestedQuantitativeFilterWidget': value.nestedQuantitativeFilterWidget,
        'nestedCategoricalFilterWidget': value.nestedCategoricalFilterWidget,
        'nestedVizTypeWidget': value.nestedVizTypeWidget,
        'nestedTableCalcWidget': value.nestedTableCalcWidget,
    };
}
exports.TableauNlpRefinementuiWidgetToJSON = TableauNlpRefinementuiWidgetToJSON;
